<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="产品编号" prop="eightBitCode">
                <el-input v-model="queryCondition.eightBitCode" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品名称" prop="eightBitCodeName">
                <el-input v-model="queryCondition.eightBitCodeName" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="供应商编号" prop="supplierCode">
                <el-input v-model="queryCondition.supplierCode" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="供应商名称" prop="supplierName">
                <el-input v-model="queryCondition.supplierName" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="产品类别" prop="categoryLevel2Code">
                <el-select v-model="queryCondition.categoryLevel2Code" clearable placeholder="请选择" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in category2CodeOptions" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onSel">选择</el-button>
      </el-row>
      <el-table ref="multipleTable" :data="tableData" border style="width: 100%">
        <el-table-column width="60">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change="setRadioCheck(scope.row)" :label="scope.row.eightBitCode"></el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="eightBitCode" label="产品编号"></el-table-column>
        <el-table-column prop="eightBitCodeName" label="产品名称"></el-table-column>
        <el-table-column prop="categoryLevel2Name" label="产品类别"></el-table-column>
        <el-table-column prop="supplierCode" label="供应商编号"></el-table-column>
        <el-table-column prop="supplierName" label="供应商名称"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import StockRecoveryApi from "@/api/StockRecovery/index";
import QIPApi from "@/api/QIP/index";
import commonFunction from "@/utils/dataTableUtils";
export default {
  name: '',
  components: {
  },
  data() {
    return {
      radioVal: '',
      tableData: [],
      category2CodeOptions: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        eightBitCode: "",
        eightBitCodeName: "",
        supplierCode: "",
        supplierName: "",
        categoryLevel2Code: ""
      },
      totalCount: 0,
      pages: 1,
    }
  },
  created() {
    this.queryData();
    this.getCategory();
  },
  methods: {
    queryData() {
      StockRecoveryApi.findEightBitListPage(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
        this.pages = res.data.pages;
      });
    },
    getCategory() {
      QIPApi.getCategory({
        categoryLevel: 2
      }).then(res => {
        console.log('res', res);
        this.category2CodeOptions = res.data
      })
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    setRadioCheck(row) {
      console.log('444', row);
      this.radioVal = row.eightBitCode
    },
    onSel() {
      console.log('radioVal', this.radioVal);
      if (!this.radioVal) {
        this.$my_message('请选择操作数据', 'error');
        return false
      }
      this.tableData.forEach(ele => {
        if (ele.eightBitCode === this.radioVal) {
          this.$emit('setSelPro', JSON.stringify(ele))
          setTimeout(() => {
            this.radioVal = ''
          }, 500);
        }
      })
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        eightBitCode: "",
        eightBitCodeName: "",
        supplierName: "",
        facilityName: "",
      }
      this.queryData();
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
